export default {
  data () {
    return {
      optionsConfirmationModal: {
        title: '',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      }
    }
  },
  methods: {
    showConfirmationMessageBox: function (message) {
      this.$bvModal.msgBoxOk(message, this.optionsConfirmationModal)
        .then(value => {
          // console.log(value)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/modalMixin.js